import React from 'react';
import PropTypes from 'prop-types';

import {WithCommonTranslations} from 'components/hocs';
import {TranslationMixin} from 'mixins';
import GmstCaptcha from "../gm-captcha/gmst-captcha/gmst-captcha";

import './Captcha.css';

export const Captcha = WithCommonTranslations(class Captcha extends TranslationMixin(React.Component) {

  componentDidUpdate(){
    this.setupTranslations();
  }

  setupTranslations() {
    let dom = this.props.captchaRef.current;
    if (dom) {
      let label = dom.labelRef.current;
      let submit = dom.submitButtonRef.current;
      let refresh = dom.refreshButtonRef.current;

      if (label) {
        label.textContent = this.getTranslation("LABEL_CAPTCHA_INSTRUCTION");
      }
      if (submit) {
        submit.textContent = this.getTranslation("LABEL_CAPTCHA_SUBMIT");
      }
      if (refresh) {
        refresh.textContent = this.getTranslation("LABEL_CAPTCHA_REFRESH");
      }
    }
  }

  render() {


    return (
        <div className='tds-captcha'>
          <GmstCaptcha  autofocus="false" session
                        send="true"
                        ref={this.props.captchaRef}/>
        </div>
    );
  }
});

Captcha.propTypes = {
  captchaRef: PropTypes.object.isRequired,
};